import ModalComponent from '../../../components/ModalComponent';
import TextFieldComponent from '../../../components/TextFieldComponent';
import DropdownComponent from '../../../components/DropdownComponent';
import ButtonComponent from '../../../components/ButtonComponent';
import { Grid2 } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { ISipClientHistoryFilterParams } from '../../../services/SipClientService/types';

interface SipVideoHistoryFilterModalProps {
  isOpen: boolean;
  onClose: () => void;
  setFilter: Dispatch<SetStateAction<ISipClientHistoryFilterParams>>;
  filter: ISipClientHistoryFilterParams;
  handleFilter: () => void;
}

const SipVideoHistoryFilterModal = ({
  isOpen,
  onClose,
  filter,
  setFilter,
  handleFilter,
}: SipVideoHistoryFilterModalProps) => {
  const callTypeOptions = [
    { label: 'Recebida', value: 'RECEIVED' },
    { label: 'Efetuada', value: 'DONE' },
    { label: 'Recusada', value: 'REFUSED' },
    { label: 'Perdida', value: 'LOST' },
  ];
  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onClose}
      title={'Filtrar histórico'}
    >
      <TextFieldComponent
        label={'De'}
        value={filter.from}
        onChangeText={(from) => setFilter((oldV) => ({ ...oldV, from }))}
      />
      <TextFieldComponent
        label={'Para'}
        value={filter.to}
        onChangeText={(to) => setFilter((oldV) => ({ ...oldV, to }))}
      />
      <DropdownComponent
        label={'Situação da chamada'}
        value={filter.callType}
        optionLabel={'label'}
        optionValue={'value'}
        options={callTypeOptions}
        onChange={(callType) => setFilter((oldV) => ({ ...oldV, callType }))}
      />
      <Grid2 container display="flex" justifyContent={'center'}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <ButtonComponent fullWidth onClick={() => handleFilter()}>
            Filtrar
          </ButtonComponent>
        </Grid2>
      </Grid2>
    </ModalComponent>
  );
};

export default SipVideoHistoryFilterModal;
